import { useState, useEffect } from 'react';
import { Prompt, useHistory, useLocation } from 'react-router-dom';
import { Location, Action } from 'history';
import { Modal } from '@/components/_common';
import Dialog from '@/components/_common/Dialog';
import styled from '@emotion/styled';

interface UseConfirmNavigationParams {
  block: boolean;
  message: string;
  title: string;
}

const useConfirmNavigation = ({ block, title, message }: UseConfirmNavigationParams) => {
  const history = useHistory();
  const location = useLocation();
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [nextLocation, setNextLocation] = useState<Location | null>(null);

  const onBlock = (_nextLocation: Location, _action: Action) => {
    if (confirmedNavigation) return true;
    const nextSearchParams = new URLSearchParams(_nextLocation.search);
    if (location.pathname !== _nextLocation.pathname || (location.search !== _nextLocation?.search && nextSearchParams.get('id') !== null)) {
      setNextLocation(_nextLocation);
      return false;
    }

    return true;
  };

  const onCancel = () => {
    setNextLocation(null);
    setConfirmedNavigation(false);
  };

  const onConfirm = () => {
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (!block) {
      setNextLocation(null);
    }
  }, [block]);

  useEffect(() => {
    if (nextLocation && confirmedNavigation) {
      history.push(nextLocation);
      setNextLocation(null);
      setConfirmedNavigation(false);
    }
    return () => {
      setConfirmedNavigation(false);
    };
  }, [confirmedNavigation, nextLocation]);

  return (
    <>
      <Prompt message={onBlock} when={block && !confirmedNavigation} />

      <Dialog
        open={!confirmedNavigation && !!nextLocation}
        title={title}
        submitText="Yes, abandon changes"
        onSubmit={onConfirm}
        cancelText="No, stay here"
        maxWidth={480}
        onCancel={onCancel}
      >
        {message}
      </Dialog>
    </>
  );
};

export default useConfirmNavigation;

const ModalWrapped = styled(Modal)`
  & > .MuiPaper-root {
    width: 400px;
    height: 235px;
    min-height: 235px;
    display: flex;
    flex-direction: column;
  }

  .MuiBox-root {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;
